module.exports = __webpack_public_path__ + "static/media/reconciliationSvg.67884189.svg";